// components/ProtectedRoute.jsx
import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const { token } = useAuth();
  const location = useLocation();
  
  // Skip protection for forgot-password and reset-password pages
  const isPublicResetPage = location.pathname.startsWith('/admin/forgot-password') || 
                            location.pathname.startsWith('/admin/reset-password');
  
  return token || isPublicResetPage ? children : <Navigate to="/admin/login" replace />;
}